export const environment = {
    production: false,
    assetUrl: 'EBUERO_STATIC_PATH_PLACEHOLDER/web-components',
    freeTrial: 'WEB_API_STATIC_FREE_TRIAL',
    login: 'WEB_API_STATIC_FREE_LOGIN',
    authApi: 'EBUERO_SERVER_PATH_PLACEHOLDER/authorization/v1',
    siteKey: 'SITE_KEY',
    crawlerAPI: 'EBUERO_SERVER_PATH_PLACEHOLDER/voice_access_api/v1',
    phoneServiceAPI : 'EBUERO_SERVER_PATH_PLACEHOLDER/phoneservice/v3',
    customerSupportAPI:'EBUERO_SERVER_PATH_PLACEHOLDER/customersupport/v1',
    localOrigin: undefined,
    localOriginValue: ''
};
